import antdEnUS from 'ant-design-vue/es/locale-provider/en_US'
import momentEn from 'moment/locale/en-gb'
import setting from './en-US/setting'
import common from './en-US/common'

const components = {
  antLocale: antdEnUS,
  momentName: 'en-gb',
  momentLocale: momentEn
}

export default {
  'message': '-',

  ...components,
  ...setting,
  ...common
}
